let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("yiDk9")).then(() => parcelRequire('9dDA7'));